export interface TrainerInterface {
  uuid: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  isAdmin: boolean;
  isActivated: boolean;
  isDeactivated: boolean;
  ID?: number;
}

export class Trainer implements TrainerInterface {
  uuid: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  isAdmin: boolean;
  isActivated: boolean;
  isDeactivated: boolean;

  constructor(
    uuid: string,
    firstName: string,
    lastName: string,
    email: string,
    phone: string,
    isAdmin: boolean,
    isActivated: boolean,
    isDeactivated: boolean
  ) {
    this.uuid = uuid;
    this.firstName = firstName;
    this.lastName = lastName;
    this.email = email;
    this.phone = phone;
    this.isAdmin = isAdmin;
    this.isActivated = isActivated;
    this.isDeactivated = isDeactivated;
  }
}
